import { render, staticRenderFns } from "./ImageCellRenderer.ts.vue?vue&type=template&id=2b5f9c42&scoped=true"
import script from "./ImageCellRenderer.ts.vue?vue&type=script&lang=ts"
export * from "./ImageCellRenderer.ts.vue?vue&type=script&lang=ts"
import style0 from "./ImageCellRenderer.ts.vue?vue&type=style&index=0&id=2b5f9c42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5f9c42",
  null
  
)

export default component.exports